import {ThankYouComponent} from './thank.you.page'

export const TEMPLATE_COMPONENTS = [
    ThankYouComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/templates/index.ts